import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import moment from 'moment';
import { ValidateSend,InfoPatient,sendSamplings,getAllTracking} from '../../services/send/sendService'
import { getListBranches } from '../../services/branches/branches';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';




export const useSend = () => {


    const treeviewRef = useRef(null);
    const idUsers = localStorage.getItem("id");
    const idBranch = localStorage.getItem("branchIdSample");
    const toastBC = useRef(null);


    const [setFocusNim, setSetFocusNim] = useState(false);
    const [typeSend, setTypeSend] = useState("send");
    const [modalSend, setModalSend] = useState(false);
    const [loading, setLoading] = useState(false);
    const [viewExams, setViewExams] = useState(false);
        const [createSweet, , , , createSweett, , , , , ,,, , , , ,, ,createSweetSend] = useSweetAlert();
    
    const [itemsTree, setItemsTree] = useState([]);
    const [listNims, setListNims] = useState([]);
    const [varSample, setVarSample] = useState("");
    const [nameBranch, setnameBranch] = useState("")

    // ? INPUT FOCUS
    const [focusNimEnabled, setFocusNimEnabled] = useState(true);
    const [forceSkipFocus, setForceSkipFocus] = useState(false);

    // * PATIENT
    const [dataPatient, setDataPatient] = useState([])
    const [loadingView, setLoadingView] = useState(false)
    const [dataArray, setDataArray] = useState([]);
    const [loadindSend, setLoadindSend] = useState(false);
    const [loadingInfoPatient, setLoadingInfoPatient] = useState(false);
    const [DetailSample, setDetailSample] = useState("")
    const [loadingInfor, setLoadingInfor] = useState(null)

    // * SEARCH PATIENT
    const [globalFilter, setGlobalFilter] = useState(null)
    const [validSearch, setValidSearch] = useState(false)    
    const [viewInfo, setViewInfo] = useState(true)
    const [hovered, setHovered] = useState(false);
    const color_incomplete = "#e56a75"; 
    const hover_incomplete = "#cd1728"; 
    const color_complete = "#51bb25"; 
    const hover_complete = "#51bb25b3"; 


    const [formNim, handleInputChangeNim, resetNim, handleUpdateValuesNim, handleSelectValuesNim] = useForm({
        nim: "",
    });

    const { nim } = formNim;

    //#region modales send
    const openModal = () => {
        setModalSend(true);
        setSetFocusNim(false);
    }

    const closeModal = () => {
        setModalSend(false);
        setSetFocusNim(true);
        handleUpdateValuesNim({
            nim: ""
        })
    }

    const handleSendSample = () => {
        setTypeSend("send");
        openModal();
        setSetFocusNim(false);
    }

    //#endregion Modales

    useEffect(() => {
        nimAutoFocus();
    }, [focusNimEnabled]);

    useEffect(() => {
        getBranches()
    }, [])


    const nimAutoFocus = () => 
    {
        if (focusNimEnabled && !forceSkipFocus) {            
            const input = document.getElementById("inputFocusNim");
            if (input) input.focus();
        }
    };

    function onKeyPressNim(_event) {
        
        if (_event.keyCode === 13) {
            
            const _mValue = _event.target.value;
            setLoading(true);

            if (_mValue.length > 0) {
                validateNim();
            } else {
                createSweett("", "Debes de ingresar un nim válido", "warning");
                handleUpdateValuesNim({ nim: "" });
                setFocusNimEnabled(true); 
                setLoading(false);
            }
        }
    }

    const getBranches = async () => 
    {
        const listBranches = await getListBranches();
    
        if (listBranches?.length > 0) {
            let _sampleBranch = listBranches.find(x => x.id_branch == (idBranch))
            setVarSample(_sampleBranch.toma)
            setnameBranch(_sampleBranch.name)

            let _process = _sampleBranch.toma === false ? 3 : 2

            setTimeout(() => {
            handleGetInformation(idUsers, _process,idBranch)
        }, 3000);
        }
    }

    
 

    //#region Patient
    const getDataNim = (e) => 
    {
        e.preventDefault();
        setLoading(true);

        if (formNim.nim.length > 0) {
            validateNim()
        }
        else {
            createSweet("", "Debes de ingresar un NIM válido", "warning");
            setLoading(false);
            return;
        }
        setLoading(false);
    }

     // ? VALIDATE SEND SAMPLING
    const validateNim = async () => 
    {
        let _proccess = varSample === false ? 3 : 2
       
        const response = await ValidateSend({
            "nim": nim,
            "id_user": idUsers,
            "id_process": _proccess,
            "id_work_order": 0,
            "id_branch": idBranch
        });

        if (response.code === 200) {
            if (response.data.code === 400) {
                setSetFocusNim(false);
                setViewExams(false);
                createSweet("warning", "warning", "Trazabilidad", response.data.message); 
                closeModal(); 
            }
            else if (response.data.code === 200) {
                if (response.data.status === "INCOMPLETA") {
                    getPatient(response?.data.id_branch, response?.data.is_toma)
                    createSweet("create", "success",  "Trazabilidad", response.data.message);
                    setLoading(false);
                    setSetFocusNim(true);
                    setViewExams(true);
                    closeModal(); 
                }
                else if (response.data.status === "INCOMPLETA_CON_CANCELADAS") {
                    getPatient(response?.data.id_branch, response?.data.is_toma)
                    createSweet("create", "success",  "Trazabilidad", response.data.message);
                    setLoading(false);
                    setSetFocusNim(true);
                    setViewExams(true);
                    closeModal(); 
                }
                else if (response.data.status === "INCOMPLETAS") {
                    createSweet("create", "warning",  "Trazabilidad", response.data.message);
                    setLoading(false);
                    setSetFocusNim(true);
                    setViewExams(false);
                    closeModal(); 
                }
                else if (response.data.status === "COMPLETA_CON_CANCELADAS") {
                     createSweet("create", "warning",  "Trazabilidad", response.data.message);
                    setLoading(false);
                    setSetFocusNim(true);
                    setViewExams(false);
                    closeModal(); 
                    
                }
                else if (response.data.status === "INCOMPLETA_2"){
                    getPatient(response?.data.id_branch, response?.data.is_toma)
                    createSweet("create", "success",  "Trazabilidad", response.data.message);
                    setLoading(false);
                    setSetFocusNim(true);
                    setViewExams(true);
                    closeModal(); 

                }
                 else if (response.data.status === "INCOMPLETA_2_CON_CANCELADAS"){
                    getPatient(response?.data.id_branch, response?.data.is_toma)
                    createSweet("create", "success",  "Trazabilidad", response.data.message);
                    setLoading(false);
                    setSetFocusNim(true);
                    setViewExams(true);
                    closeModal(); 

                }
                else {
                  
                    createSweetSend( varSample === false ? "recepción completada" : "Envio completado" );
                    setLoading(false);
                    setSetFocusNim(true);
                    setViewExams(false);
                    closeModal(); 
                }
            }
        }
        else {
            setSetFocusNim(false);
            setViewExams(false);
            createSweet("error", "error", "Trazabilidad", response.data.msg);
            closeModal(); 
        }   
    }



    // ? INFO PATIENT
    const getPatient = async (_id_branch, is_toma) => 
    {
         const response = await InfoPatient({
            "nim": nim,
            "id_departament": 1,
        });

        if (response.code === 200) {
                 
            let _validBranch = is_toma === true ? "Sample" : "Matriz"
            let _validBranchs = varSample === true ? "Sample" : "Matriz"
            console.log("🚀 ~ useSend ~ _validBranchs:", _validBranchs)
         
            if ( _validBranchs === "Sample" ) {    
                if (String(_id_branch) === String(idBranch)) {
                    if (response?.data?.lista_pruebas.length > 0) {
                        setLoadingView(true)
              
                        const list =  response?.data?.lista_pruebas.map(_find => {

                            return {
                                name_patient: _find?.name_patient ?? "---",
                                nim: _find?.nim ?? "---",
                                age: _find?.age ?? "---",
                                admision_date: _find?.admision_date ?? "---",
                                gender: _find?.gender ?? "---"
                            }
                        });
                        setDataPatient(list);
                        setDetailSample(_validBranch)

                        const profilesExams = response?.data.lista_pruebas.map(({ listProfile, listExam }) => ({
                                profiles: listProfile ?? [],
                                exams: listExam ?? [],
                            }));

                        const tree = createTree(profilesExams,is_toma);
                        setItemsTree(tree);
                    }   
                }
                else
                {
                    setItemsTree([]);
                    setLoadingView(false)
                    setViewExams(false);
                    createSweet("error", "error", "Trazabilidad", "Este nim no corresponde a esta sucursal");
                }
            }
            else {
                console.log("pasas aqui porque recibes todo");
                
                  if (response?.data?.lista_pruebas.length > 0) {

                    const list =  response?.data?.lista_pruebas.map(_find => {

                    return {
                        name_patient: _find?.name_patient ?? "---",
                        nim: _find?.nim ?? "---",
                        age: _find?.age ?? "---",
                        admision_date: _find?.admision_date ?? "---",
                        gender: _find?.gender ?? "---"
                    }
                });
                setDataPatient(list);
                const profilesExams = response?.data?.lista_pruebas.map(({ listProfile, listExam }) => ({
                        profiles: listProfile ?? [],
                        exams: listExam ?? []
                    }));

                            console.log("🚀 ~ useSend ~ is_toma:", is_toma)


                const tree = createTree(profilesExams,is_toma);
                setItemsTree(tree); 
               }    
            } 
        }
        else {
            setDataPatient([]);
            setLoadingView(false)
        }
    }

    const handleCloseViewSend = () => 
    {        
        setSetFocusNim(true);
        setViewExams(!viewExams);
        setLoadindSend(false);
        setItemsTree([]);
        setDataPatient([]);
        setDataArray([]);
        setViewInfo(true)

    }

    // ? CREATE EXAMS AND PROFILE

    const createTree = (_arrayNuevo,_process_sample) => 
    {
            console.log("🚀 ~ useSend ~ is_toma1:", _process_sample)

        let _tree = [];
        let _specimen = ""
        _arrayNuevo.forEach(_find => {
            
                if (_find.exams.length > 0) {
                    _find.exams.forEach(_e => {
                        _specimen = _e?.name_specimen_origin ?? ""
                        _tree.push({
                            "children": [],
                            "id": _e?.id_work_order_exam,
                            "state": (_e?.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? 2 : _e?.refused_check_specimen === false ? 1 : 2,
                            "text": _e?.name + " - " + _specimen,
                            "isLeaf": _e?.check_specimen,
                            "refused_check_specimen": (_e?.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? true : _e?.refused_check_specimen,
                            "is_send1": _e?.is_send1,
                            "is_send2": _e?.is_send2,
                            "check_forwarded": _e?.check_forwarded,
                            "specimen": _specimen,
                            "process": varSample === true ? 1 : 2,
                            "id_work_order": _e?.id_work_order,
                            "id_work_order_exam": _e?.id_work_order_exam,
                            "nim": formNim.nim,
                            "is_toma": _e?.is_toma,
                            "id_branch": idBranch ?? idBranch,
                            "is_proccess_sample": _process_sample
                        });
                    });
                }

                if (_find.profiles.length > 0) {
                    _find.profiles.forEach(_p => {
                        let examenes_aux = [];
                        let id = true;
                        let checy = 0;
                        let is_send1 = false;
                        let is_send2 = false;
                        let check_forwarded = false;
                        let id_work_order = 0

                        _p.listExam.forEach((_e) => {
                            _specimen = _e?.name_specimen_origin ?? ""
                            examenes_aux.push({
                                "id": _e.id_work_order_exam,
                                "isLeaf": _e.check_specimen,
                                "state": (_e.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? 2 : _e.refused_check_specimen === false ? 1 : 2,
                                "text": _e.name ,
                                "refused_check_specimen": (_e.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? true : _e.refused_check_specimen,
                                "is_send1": _e.is_send1,
                                "is_send2": _e.is_send2,
                                "check_forwarded": _e.check_forwarded,
                                "id_work_order": _e?.id_work_order,
                                "is_toma": _e?.is_toma,
                                "id_branch": idBranch ?? idBranch
                            });
                            id = _e.check_specimen;
                            checy = (_e.check_forwarded === false && (_e?.is_toma === '' || _e?.is_toma === undefined)) ? 2 : _e.refused_check_specimen === false ? 1 : 2;
                            is_send1 = _e.is_send1;
                            is_send2 = _e.is_send2;
                            check_forwarded = _e.check_forwarded;
                            id_work_order = _e?.id_work_order
                        });

                        _tree.push({
                            "children": examenes_aux,
                            "state": checy,
                            "text": _p.name_profile + " - " +_specimen,  
                            "isLeaf": id,
                            "is_send1": is_send1,
                            "is_send2": is_send2,
                            "check_forwarded": check_forwarded,
                            "specimen": _specimen,
                            "process": varSample === true ? 1 : 2,
                            "id_work_order":id_work_order,
                            "nim": formNim.nim,
                            "id_branch": idBranch ?? idBranch,
                            "is_proccess_sample": _process_sample

                        });
                    });
                }
        });

        setDataArray(_tree);
        return _tree;
    };

    const changeTree = (e) => {
        changeStatus(e)
    }

    // ? CHANGE 
    const changeStatus = async (e) => 
    {

        const api = treeviewRef.current.api
        const items = api.getItems();
    
        let pending2 = [];

        items.forEach(_find => {
            if (_find?.id !== undefined) {
                if (_find.state === 2) {
                    pending2.push({
                        "id_work_order": 0,
                        "id_work_order_exam": _find.id,
                        "list_refusedTracking": [
                            {
                                "refused_check_specimen": _find.state === 2 ? true : false,
                                "text": _find.text
                            }
                        ]
                    });
                }
                if (_find.state === 1) {
                    pending2.push({
                        "id_work_order": 0,
                        "id_work_order_exam": _find.id,
                        "entra": 0,
                        "list_refusedTracking": [
                            {
                                "refused_check_specimen": false,
                                "text": _find.text
                            }
                        ]
                    });
                }
            }

            //profiles
            else {
                _find.children.forEach(ex => {
                    if (ex.state === 2) {
                        pending2.push({
                            "id_work_order": 0,
                            "id_work_order_exam": ex.id,
                            "list_refusedTracking": [
                                {
                                    "refused_check_specimen": ex.state === 2 ? true : false
                                }
                            ]
                        });
                    }

                    if (ex.state === 1) {
                        pending2.push({
                            "id_work_order": 0,
                            "id_work_order_exam": ex.id,
                            "entra": 0,
                            "list_refusedTracking": [
                                {
                                    "refused_check_specimen": false,
                                    "text": _find.text
                                }
                            ]
                        });
                    }
                })
            }
        });
       // setPendingSample(pending2)
    }

    // ? SEND PROCESS

    const saveSendSample = async () => 
    {
    let _array = dataArray;

    let _validBranchs = varSample === true ? "Sample" : "Matriz";
    let _message = varSample === true ? "Éxito en el envío de las muestras" : "Éxito en recibir las muestras";
    let _process = varSample === false ? 3 : 2;

    _array = _array.map(item => {
        if (_validBranchs === "Sample" ) {
             if (Array.isArray(item.children) && item.children.length > 0) {
            const filteredChildren = item.children.filter(
                child => child.is_toma === true || child.check_forwarded === true
            );

            if (filteredChildren.length === 0) return null;

            const updatedChildren = filteredChildren.map(child => ({
                ...child,
                is_send1: child.state === 1,
            }));

            const allSend1 = updatedChildren.every(child => child.is_send1 === true);

            if (_validBranchs === "Sample" && DetailSample === "Sample") {
                return {
                    ...item,
                    children: updatedChildren,
                    is_send1: allSend1,
                };
            } else {
                return {
                    ...item,
                    children: updatedChildren,
                    is_send2: item.state === 1,
                };
            }

        } else {
            const isValid = item.is_toma === true || item.check_forwarded === true;

            if (!isValid) return null;

            if (_validBranchs === "Sample" && DetailSample === "Sample") {
                return {
                    ...item,
                    is_send1: item.state === 1,
                };
            } else {
                return {
                    ...item,
                    is_send2: item.state === 1,
                };
            }
        }
            
        }
        else {
         
        if (Array.isArray(item.children) && item.children.length > 0) {
            const filteredChildren = item.children.filter(
                child => child.is_toma === true || child.check_forwarded === true
            );

            if (filteredChildren.length === 0) return null;

            const updatedChildren = filteredChildren.map(child => {
                const base = {
                    ...child,
                    is_send2: child.state === 1,

                };

                if (item.is_proccess_sample === false) {
                    base.is_send1 = child.state === 1;
                }

                return base;
            });

            const allSend2 = updatedChildren.every(child => child.is_send2 === true);

            return {
                ...item,
                children: updatedChildren,
                is_send2: allSend2,
                is_send1: true,

            };

        } else {
            const isValid = item.is_toma === true || item.check_forwarded === true;

            if (!isValid) return null;

            const base = {
                ...item,
                is_send2: true,
                is_send1: true,

                
            };

            if (item.is_proccess_sample === false) {
                base.is_send1 = true;
            }

            return base;
        }
            }
        });

        _array = _array.filter(item => item !== null);
        console.log("🚀 ~ useSend ~ _array:", _array)

       const response = await sendSamplings(_array);

        if (response?.code === 200) {
            createSweet("create", "success",  "Trazabilidad", _message);
            setItemsTree(_array)
            setLoadindSend(true);

            setTimeout(() => {
                handleGetInformation(idUsers, _process,idBranch)
            }, 300);            
            handleCloseViewSend();

        }
        else {
            createSweet("error", "error", "Trazabilidad", "Ocurrio un problema");
        }
   };

    // ? SEARCH INFO PATIENT
    const handleInfo = async (_nim) =>
    {
        setLoadingInfor(_nim);
        setViewExams(false)
        setItemsTree([]);
        setDataPatient([]);
        setDataArray([]);
        setTimeout(() => {
              getInfoPatient(_nim);
            }, 3000);
    }


    const getInfoPatient = async (_nim) => 
    {
        setLoadingInfoPatient(true);

         const response = await InfoPatient({
            "nim": _nim,
            "id_departament": 1,
        });

        if (response.code === 200) {
            if (response?.data?.lista_pruebas.length > 0) {
                setLoadingInfoPatient(false)
                setViewExams(true)
                setLoadingInfor(null)
                setViewInfo(false)
                const list =  response?.data?.lista_pruebas.map(_find => {

                return {
                        name_patient: _find?.name_patient ?? "---",
                        nim: _find?.nim ?? "---",
                        age: _find?.age ?? "---",
                        admision_date: _find?.admision_date ?? "---",
                        gender: _find?.gender ?? "---"
                    }
                    });
                setDataPatient(list);

                const profilesExams = response?.data.lista_pruebas.map(({ listProfile, listExam }) => ({
                    profiles: listProfile ?? [],
                    exams: listExam ?? [],
                }));

                const tree = createTree(profilesExams);
                setItemsTree(tree);
                }   
        }   
        else {
            setDataPatient([]);
            setLoadingInfoPatient(false)
        }
    }

    const handleGetInformation = async (_idUsers, _proces, _id_branch) => 
    {
        setLoading(true);

        const trackingData = await getAllTracking(_idUsers, _proces,_id_branch);    

        if (trackingData?.code === 200) {
            setLoading(false);
            setListNims(trackingData?.data?.trackingListNim)
        }
        else setLoading(false);
    }

    const customBody = (rowData) => 
    {
        return (
            <Badge style={{boxShadow:"0 0 8px rgba(245, 183, 26, 0.5)"}} value={rowData?.nim  ?? "---"} severity="warning"></Badge>
        );
    };

    const showConfirmationToast = () => 
    {
        toastBC.current.show({
            severity: 'error',
            summary: '¿Deseas regresar a escanear otra muestra?',
            sticky: true,
            content: (props) => (
                <div
                    className="flex flex-column align-items-center justify-content-center"
                    style={{ width: "600px", padding: "1rem", textAlign: "center" }}
                >
                    <div className="mb-2">
                        <strong className="text-900" style={{ fontSize: "18px" }}>
                            Escaneo de nueva muestra
                        </strong>
                    </div>
                      <div className="mb-3" style={{ fontWeight: "500" }}>
                    Esta acción te regresará al registro.<br />¿Deseas continuar?
                </div>
                    <div
                        className="d-flex justify-content-center"
                        style={{ gap: "1rem", marginTop: "1rem" }}
                    >
                       <Button
                            label="Confirmar"
                            className="p-button-success"
                            style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                            size="small"
                            onClick={() => {
                                try {
                                    if (toastBC.current) toastBC.current.clear();
                                    handleCloseViewSend();
                                } catch (error) {
                                    console.error("Error al cerrar vista:", error);
                                }
                            }}
                        />
                        <Button
                            label="Cancelar"
                            className="p-button-danger"
                            style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}
                            size="small"
                            onClick={() => toastBC.current.clear()}
                        />
                    </div>
                </div>
            )
        });
    };


    const customBodyEstatus = (rowData) => 
    {
        return (
                <button
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    style={rowData?.complete ? {
                        backgroundColor: hovered ? hover_complete : color_complete,
                        border: "none",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        color: "#fff",
                        fontWeight: "bold",
                        cursor: "pointer",
                        transition: "background-color 0.3s ease",
                        boxShadow: hovered
                            ? "0 0 12px rgba(26, 205, 43, 0.6)"
                            : "0 0 8px rgba(143, 240, 177, 0.5)",
                        borderRadius: "999px" 
                    } : {
                        backgroundColor: hovered ? hover_incomplete : color_incomplete,
                        border: "none",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        color: "#fff",
                        fontWeight: "bold",
                        cursor: "pointer",
                        transition: "background-color 0.3s ease",
                        boxShadow: hovered
                            ? "0 0 12px rgba(196, 40, 40, 0.6)"
                            : "0 0 8px rgba(240, 143, 143, 0.5)",
                        borderRadius: "999px" 
                    }}
                >
                    {rowData?.complete ? "Completo" : "Incompleto"  ?? "---"} 
                </button>
        );
    };

    //#endregion Patient

    
   

    return {

        // * MODAL AND KEYS NIM
        typeSend, modalSend, openModal, closeModal, handleSendSample, nimAutoFocus, onKeyPressNim, getDataNim,
        handleSelectValuesNim, nim, handleInputChangeNim,loading,

        // * EXAM AND PROFILES
        treeviewRef, itemsTree, listNims,varSample,changeTree, saveSendSample,viewExams,
   
        // * NEW METHODS
        dataPatient,loadingView,loadindSend,nameBranch,showConfirmationToast,toastBC,
        focusNimEnabled,

        // * SEARCH TABLE PATIENT
        handleInfo,loadingInfor,customBody,
        globalFilter,setGlobalFilter,validSearch, setValidSearch,viewInfo,customBodyEstatus

    }

}


